import React, { Component } from 'react';
import TutorProfileLayout from './TutorProfileLayout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { history } from '../../../../helpers';
import Subjects from './partials/Subjects';

class SetPrices extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formField: {
                firstName: '',
                lastName: '',
            },
            loading: false,
        };
    }

    componentDidMount() {
        localStorage.setItem('activeStep', 2);
    }


    nextButton = () => {
        localStorage.setItem('activeStep', 3);
        history.push('/tutor/set-availability');
    };

    backButton = () => {
        localStorage.setItem('activeStep', 1);
        history.push('/tutor/background');
    }

    render() {

        return (<TutorProfileLayout activeClass="TutorProfile">
            <div className="background-page">
                <div className="py-4">
                    <Subjects />
                </div>
                <div className="form-group text-center">
                    <hr />
                    <button className="btn btn-primary mx-2" type="submit" onClick={this.backButton}>Back</button>
                    <button className="btn btn-info mx-2 text-uppercase" onClick={this.nextButton}>Next</button>
                    <hr />
                </div>
                <div className="row">
                    <div className="col-lg-8 col-md-12 col-12 text-center mx-auto">
                        <img src="/images/b-tutor.png" width="100%"/>
                    </div>
                </div>
            </div>
        </TutorProfileLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);
const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);
const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(SetPrices);